import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';

export const Dashboard: React.FC = () => {
  return (
    <div>
      <h1>Platform Dashboard</h1>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Card>
            <Statistic title="Total Tenants" value={150} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="Active Users" value={1200} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="Revenue (MTD)" value={125000000} suffix="đ" />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="Support Tickets" value={12} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};
